
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import resultDialog from "@/components/publicComponents/resultDialog";
import {
setChannel,
getSStore,
setSStore,
IsValid,
getBefore,
getHind,
format,
isCjWxChannel,
getUrlObj,
saveToken,
getXAccountUrl2,
setLStore,
getLStore
} from "@js/public/mUtils";
import sLoading from "@/components/publicComponents/sLoading";
import Pwd from "@/components/publicComponents/pwd";
import * as myCode from "@js/public/code";
import WXConfig from '@/assets/js/wx.jsapi'
export default {
components: {
Cell,
Group,
Toast,
Swiper,
SwiperItem,
XButton,
XDialog,
resultDialog,
"my-sloading": sLoading,
"my-pwd": Pwd,
},
name: "Home",
data() {
return {
isProtocolRead:true,
timeDialog:false,
timeDialog2:false,
main: false,
pwdModel: false,
pwdModel2: false,
investHot: [],
mesStyle: { width: '300', height: '290' },
bannerslist: [















],
trainShow:false,
trainObj: {},
trainArr: [],
imgURLlist: [], // 图片base64
bannerIndex: 0,
choicenessHot: {}, // 热门精选
reasonFund: [], // 热门精选基金标签
openResult: {},
openFlag: false,
trainNotice: false
};
},
activated() {
this.eventBus.$emit("changeMenu", 0);
this.$store.commit('tabBarNumber', 0);
this.getUserInfo()
this.getRefreshAndSync()
this.getTargetCardInfo()
this.WXConfig.wxShowMenu('2')



},
created() {
setChannel();
if(getSStore('mccode') == null) {
setSStore('mccode','wx')
}
if(getSStore('sccode') == null) {
setSStore('sccode','wx_gzh')
}
if(getSStore('source') == null) {
setSStore('source','wx')
}
const urlObj = getUrlObj(window.location.href)
if (urlObj.hasOwnProperty('token')) {
saveToken(urlObj.token);
}
this.$emit("changeMenu", 0);
var _this = this;
if (this.$store.state.logined) {
this.getUserInfo();
if (isCjWxChannel()) {
this.checkBindOpenId();
}
}
this.bannerBase64();
this.mainLoaded(this);
this.getInvestHot();
this.getChoicenessHot();

const trainNoticeShow = getLStore('trainNoticeShow') || ''
if (trainNoticeShow === '') {
this.trainNotice = true
} else {
this.judgeUpgrade();
}
},
computed: {},
mounted() {
this.$emit("changeTab", 0);
window.onscroll = null;
},
methods: {
closeToast() {
this.trainNotice = false
this.judgeUpgrade();
},
goToast() {
setLStore('trainNoticeShow', 'istrue')
this.trainNotice = false
this.judgeUpgrade();
},
toPdf(isProtocolRead) {
if (isProtocolRead) {
return false;
}
setSStore("isFromPdf", "1");
this.toPage("/pdf", { url: '@/../static/file/创金合信基金管理有限公司网上交易定期定额投资业务协议.pdf', showConfirm: true });
},

judgeUpgrade() {
return this.$http.post("/autoInvestPlan/check", {}).then((res) => {
if (res.code === 0) {
this.timeDialog = res.body.isConfirm===0;
}
});
},
agree(){
if(this.isProtocolRead){
this.timeDialog = false;
this.pwdModel2 = true;
}else {
this.$vux.alert.show("请阅读相关协议");
}
},
refuse(){
if(this.isProtocolRead){
this.timeDialog = false;
this.timeDialog2 = true;
}else {
this.$vux.alert.show("请阅读相关协议");
}
},
postBuy(pwd) {
this.pwdModel2 = false;
this.$http.post("/autoInvestPlan/agree", {
pwd:pwd
}).then((res) => {});
},
refuseGo() {
this.timeDialog2 = false;
this.$http.post("/autoInvestPlan/disagree", {}).then((res) => {
if(res.code===0){
this.toPage('/myTimeInvest', {})
}
});
},
refuseCancel(){
this.timeDialog2 = false;
this.timeDialog = true;
},
getRefreshAndSync() { // 刷新用
this.$http.post("/customer/refreshAndSync", {}).then(res => {})
},
bannerBase64(){
var baseURL = window.location.protocol + '//' + window.location.host;

this.$http.get(
baseURL + "/api/banner/getBannerList")
.then((data)=>{
if (data.body && data.body.bannerList && data.body.bannerList.length>0) {
const arrList = []
for (let index = 0; index < data.body.bannerList.length; index++) {

if (data.body.bannerList[index].type == '2') {
arrList[index] = {}
arrList[index].url = ''
arrList[index].title = data.body.bannerList[index].title
arrList[index].img = data.body.bannerList[index].imgUrl
arrList[index].fundCode = data.body.bannerList[index].fundCode
arrList[index].type = data.body.bannerList[index].type
} else {
arrList[index] = {}
arrList[index].url = data.body.bannerList[index].link
arrList[index].title = data.body.bannerList[index].title
arrList[index].img = data.body.bannerList[index].imgUrl
arrList[index].fundCode = ''
arrList[index].type = data.body.bannerList[index].type
}
}
this.bannerslist= arrList
}













})
.catch((err)=> {
console.log(err);
})
},
goTrain() {

this.sa.track('first_page_button_click', {
second_module: '小火车',
third_module:' 小火车',
button_name: '跟车赚钱'
})

this.$http.post("/customer/state", {}).then((res) => {
if (res.code === 0) {
if (!res.body.state) {

if (res.body.certValid == "10") {
const result = {
title: "您还未开户",
content: "完成实名绑卡后，即可进行下一步哦",
description: "",
icon: "warn",
buttons: [
{
type: "primary",
text: "去实名",
link: "/registerTwo?action=register&source=wx",
active: true,
},
{
type: "default",
text: "关闭",
link: "-2",
active: false,
},
],
};
this.mesStyle = { width: '300', height: '290' }
this.openResult = result;
this.openFlag = true;
}  else if (res.body.certValid == "11") {
const result = {
title: "提示",
content: res.body.message,
description: "",
icon: "warn",
buttons: [
{
type: "primary",
text: "确定",
link: "-2",
active: true,
}
],
};
this.mesStyle = { width: '300', height: '230' }
this.openResult = result;
this.openFlag = true;
} else {
const result = {
title: "去完善个人信息",
content: res.body.message,
description: "",
icon: "warn",
buttons: [
{
type: "primary",
text: "去完善",
link: "/personal",
active: true,
},
{
type: "default",
text: "关闭",
link: "-2",
active: false,
},
],
};
this.mesStyle = { width: '300', height: '290' }
this.openResult = result;
this.openFlag = true;
}
} else {
const xAccountUrl = getXAccountUrl2("pages/home/product/product", '1');
window.location.href = xAccountUrl
}
}
})
},
getTargetCardInfo() {
this.$http.post("/assist/getTargetCardInfo", {}).then((res) => {
if (res.code === 0) {
if (JSON.stringify(res.body.info) == "{}" || res.body.info == null) {
this.trainShow = false
} else {
this.trainObj = res.body.info
this.trainObj.earningRate = Number(this.trainObj.earningRate).toFixed(2)
this.trainArr = this.trainObj.labels.split('，')
if (this.trainObj.status === '1' && getSStore("xhcWl") === '0') {
this.trainShow = true
} else {
this.trainShow = false
}
}
}
})
},
myFormat(type, value) {
if (type === "00.00%") {
if (value > 0) {
return "+" + format(type, value);
}
}
return format(type, value);
},

getInvestHot() {
return this.$http.post("/fund/list/hotSpot", {}).then((res) => {
this.loaded()
if (res.code === 0) {
if (res.body.list.length > 0) {
for (let index = 0; index < res.body.list.length; index++) {
if(res.body.list[index].fundName.length > 9) {
res.body.list[index].fundName = res.body.list[index].fundName.substring(0,9) + '...'
}
}
}
this.investHot = res.body.list;
}
});
},

getChoicenessHot() {
return this.$http.post("/fund/list/choiceness", {}).then((res) => {
this.loaded()
if (res.code === 0) {
this.choicenessHot = res.body.list[0];
this.reasonFund = res.body.list[0].reason.split(",");
}
});
},

getDayinc(val) {
return (val * 100).toFixed(2);
},

clickExpect() {
this.$vux.toast.show({
width: "12em",
type: "text",
text: "暂未开放，敬请期待哦",
});
},

goBuy(fundCode, bizType = false, item, index = '') {
const params = {
fundCode: fundCode
};
if (bizType) {
params.bizType = bizType;
}
if (bizType) {
this.sa.track('first_page_button_click', {
second_module: '热门精选',
button_name: '立即购买'
})
} else {
this.sa.track('first_page_button_click', {
second_module: '投资热点',
button_name: item.title,
third_module: '投资热点',
module_sort: index + 1,
content_id: fundCode,
content_name: item.title
})
}
this.toPage('/productDetail', params);
},
goBannerPage(val) {
this.sa.track('first_page_button_click', {
second_module: 'banner',
button_name: 'banner',
third_module: 'banner',
module_sort: val,
content_id: val == 0 ? '005927' : val == 2 ? '013339' : '',
content_name: this.bannerslist[val].title
})
const bannerNum = Number(val)
if (this.bannerslist[bannerNum].type && this.bannerslist[bannerNum].type === '2' && this.bannerslist[bannerNum].fundCode && this.bannerslist[bannerNum].fundCode !== '') {
this.toPage("/productDetail", { fundCode: this.bannerslist[bannerNum].fundCode });
}









},

checkBindOpenId() {
const _this = this;
this.$http.post("/customer/openid/check", {}).then((res) => {
if (res.code === myCode.NO_BIND) {

this.$vux.confirm.show({
content: "未绑定微信号，您要此绑定微信号吗？",
onConfirm() {
_this.pwdModel = true;
},
});
} else if (res.code === myCode.NO_SAME_BIND) {

this.$vux.alert.show("此微信号与绑定微信号不一致， 请注意账号安全");
}
});
},


bindOpenId(pwd) {
this.closePwd();
this.$http.post("/customer/openid/bind", { pwd: pwd }).then((res) => {
if (res.code === 0) {
this.$vux.toast.show({
type: "text",
text: "绑定成功",
});
} else {
this.$vux.toast.show({
type: "text",
text: "绑定失败",
});
}
});
},

getUserInfo() {
this.$http.post("/customer/info", {}).then((res) => {
if (res.code === 0) {
this.sa.registerPage({ is_login: true });
setSStore("personalCenterUserInfo", res.body.info);
setSStore("custIds", res.body.info.custId);
this.hotSellShow = !res.body.info.c0;

this.sendData(res.body.info);

if(res.body.info.fundAcct.split('')[0]==='3'){
this.sa.login(res.body.info.fundAcct)
}
} else {
this.sa.registerPage({ is_login: false });
}
});
},
sendData(user){
if (user.birthday) {
let year = user.birthday.substring(0, 4);
let month = user.birthday.substring(4, 6);
let day = user.birthday.substring(6);
this.birthday = year + "-" + month + "-" + day;
}
let profile = {
cust_no: user.clientId,  // 之前上报的
cust_name: user.name,
cust_gender: user.sex==='1'?'男':'女',
age: new Date().getFullYear() - Number(user.birthday.substr(0, 4)),
Birthday: this.myFormat('YYYY-MM-DD', this.birthday),
id_type: user.identityTypeStr,
id_number: user.identityNo,
id_expiration: user.invalidate,
phone_number: [user.mobile],
tel: user.mobile,
id_province: user.province,
id_city: user.city,
region: user.detailAddr,
address: user.detailAddr, // 详细地址
email: user.email, // 邮箱
zip_code: user.postalCode, // 邮政编码

occupation: user.workStr, // 职业
control_person: user.isAgent == 1 ? true : false,  // 是否存在其他代理人
is_beneficiary: user.isBeneficiary == 1 ? true : false,  // 受益人
is_politician: user.isActualCtrl == 1 ? true : false,  // 实控人
};
this.sa.setProfile(profile);
},

closePwd() {
this.pwdModel = false;
},
},
};



// WEBPACK FOOTER //
// ./src/components/home/home.vue